import * as React from "react";
const SvgFiRrToiletPaperUnderSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-toilet-paper-under-slash_svg__a)">
      <path
        fill="#062147"
        d="M22.258 18.858c-.227-.09-.297-.172-.268-1.292.004-.184.01-9.066.01-9.066 0-.119-.022-1.234-.06-1.34C21.573 3.052 19.534 0 17 0H5c-.89 0-1.753.38-2.499 1.087L1.707.293A.999.999 0 1 0 .293 1.707l22 22a.997.997 0 0 0 1.414 0A1 1 0 0 0 24 23v-1.654c0-1.089-.684-2.065-1.742-2.488m-2.247-.26-1.828-1.829c.671-.267 1.286-.757 1.817-1.425 0 0-.004 2.003-.009 2.17-.009.335-.018.708.02 1.083M20.001 8.5c0 3.831-1.582 6.5-3 6.5-.345 0-.698-.157-1.035-.448l-.307-.307C14.74 13.193 14 11.118 14 8.5 14 4.67 15.581 2 17 2s3 2.67 3 6.5M5 2h8.744C12.672 3.547 12 5.866 12 8.5c0 .785.06 1.541.172 2.258L3.916 2.502C4.211 2.23 4.584 2 5 2m13.5 21a1 1 0 0 1-1 1H13c-2.758 0-5-2.243-5-5v-2H5c-2.805 0-5-3.733-5-8.5 0-.729.051-1.45.153-2.146a1 1 0 0 1 1.979.291A13 13 0 0 0 2 8.5C2 12.331 3.581 15 5 15h6a1 1 0 0 1 0 2h-1v2c0 1.654 1.346 3 3 3h4.5a1 1 0 0 1 1 1M17 7c.551 0 1 .672 1 1.5s-.449 1.5-1 1.5c-.553 0-1-.672-1-1.5S16.447 7 17 7"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-toilet-paper-under-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToiletPaperUnderSlash;
